import React, { useState } from "react";
import { db } from "../firebase"; 
import { collection, addDoc } from "firebase/firestore";
import Groq from "groq-sdk";

const groq = new Groq({
  apiKey: process.env.REACT_APP_GROQ_API_KEY,
  dangerouslyAllowBrowser: true 
});

function AdminDashboard() {
  const [type, setType] = useState("article");
  const [topic, setTopic] = useState("");
  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState(null);

  // FONCTION : Chercher une image sur Unsplash
  const fetchUnsplashImage = async (query) => {
    try {
      const response = await fetch(
        `https://api.unsplash.com/search/photos?query=${query}&per_page=1&client_id=${process.env.REACT_APP_UNSPLASH_KEY}`
      );
      const data = await response.json();
      return data.results[0]?.urls?.regular || "https://images.unsplash.com/photo-1542751371-adc38448a05e";
    } catch (error) {
      return "https://images.unsplash.com/photo-1542751371-adc38448a05e";
    }
  };

  const generateContent = async () => {
    if (!topic) return alert("Précise le sujet !");
    setLoading(true);
    
    try {
      const chatCompletion = await groq.chat.completions.create({
        messages: [
          {
            role: "user",
            content: `Tu es le rédacteur en chef de GamePulse HQ. Rédige un article de fond EXTRÊMEMENT COMPLET et LONG sur "${topic}".
            
            INSTRUCTIONS CRUCIALES :
            1. Longueur : Minimum 1000 mots pour une analyse profonde.
            2. Formatage : Utilise des titres H2, H3, du gras, et obligatoirement un TABLEAU Markdown pour les specs techniques ou les notes.
            3. Images : Inclus la balise EXACTE "[IMAGE_INTERNE]" entre deux paragraphes à 2 ou 3 reprises dans le texte.

            STRUCTURE JSON :
            {
              "title": "Titre SEO Impactant",
              "slug": "url-du-jeu-2026",
              "searchQuery": "Mot clé pour l'image de couverture",
              "content": "Tout l'article long avec les balises [IMAGE_INTERNE] et les tableaux.",
              "internalKeywords": ["gameplay", "graphics"],
              "review": {
                "score": "Note /20",
                "pros": ["Point fort 1", "Point fort 2"],
                "cons": ["Point faible 1"],
                "verdict": "Conclusion finale"
              }
            }`,
          },
        ],
        model: "llama-3.3-70b-versatile", 
        response_format: { type: "json_object" } 
      });

      let responseData = JSON.parse(chatCompletion.choices[0]?.message?.content);
      
      // 1. Récupérer l'image de couverture
      const mainImage = await fetchUnsplashImage(responseData.searchQuery);
      
      // 2. Récupérer les images pour l'intérieur
      let finalContent = responseData.content;
      const internalImg1 = await fetchUnsplashImage(responseData.internalKeywords[0] || topic);
      const internalImg2 = await fetchUnsplashImage(responseData.internalKeywords[1] || "gaming");

      // 3. Remplacement des balises par les images (une par une pour avoir des images différentes)
      finalContent = finalContent.replace("[IMAGE_INTERNE]", `\n\n![Illustration 1](${internalImg1})\n\n`);
      finalContent = finalContent.replace("[IMAGE_INTERNE]", `\n\n![Illustration 2](${internalImg2})\n\n`);

      setPreview({ 
        ...responseData, 
        content: finalContent, 
        image: mainImage 
      });
      
    } catch (error) {
      console.error("Erreur:", error);
      alert("Erreur lors de la génération riche");
    }
    setLoading(false);
  };

  const publishToFirebase = async () => {
    try {
      const collectionName = type === "article" ? "articles" : "games";
      await addDoc(collection(db, collectionName), {
        ...preview,
        date: new Date().toLocaleDateString("fr-FR"),
        author: "Mamadou Ly",
        buyLink: `https://www.instant-gaming.com/fr/search/?q=${encodeURIComponent(preview.title)}&igr=gamer-bc1658d`
      });
      alert(`🚀 Article riche publié sur GamePulse HQ !`);
      setPreview(null);
      setTopic("");
    } catch (e) {
      alert("Erreur Firebase : " + e.message);
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={{ color: "#00ffcc" }}>🚀 GamePulse HQ - Générateur d'Articles Riches</h1>
      
      <div style={{ marginBottom: "20px" }}>
        <button onClick={() => setType("article")} style={type === "article" ? styles.activeTab : styles.tab}>Article de Fond</button>
        <button onClick={() => setType("game")} style={type === "game" ? styles.activeTab : styles.tab}>Test Complet</button>
      </div>

      <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
        <input 
          style={styles.input}
          value={topic}
          onChange={(e) => setTopic(e.target.value)}
          placeholder="Ex: Analyse technique de Ghost of Yotei..."
        />
        <button onClick={generateContent} disabled={loading} style={styles.btn}>
          {loading ? "Rédaction en cours (1000+ mots)..." : "Générer l'Article Long"}
        </button>
      </div>

      {preview && (
        <div style={styles.previewCard}>
          <img src={preview.image} alt="Couverture" style={styles.previewImg} />
          <h2 style={{ color: "#00ffcc" }}>{preview.title}</h2>
          <div style={styles.scrollContent}>
             {/* Aperçu rapide du code généré */}
            <pre style={{ whiteSpace: "pre-wrap", color: "#888", fontSize: "0.7rem" }}>{preview.content}</pre>
          </div>
          <button onClick={publishToFirebase} style={styles.publishBtn}>PUBLIER L'ARTICLE RICHE</button>
        </div>
      )}
    </div>
  );
}

const styles = {
  container: { padding: "80px 20px", color: "white", maxWidth: "1000px", margin: "0 auto", textAlign: "center", background: "#0f0f1b", minHeight: "100vh" },
  tab: { background: "none", border: "none", color: "#666", padding: "10px 20px", cursor: "pointer", fontSize: "1rem" },
  activeTab: { background: "none", borderBottom: "3px solid #ec008c", color: "#fff", padding: "10px 20px", fontWeight: "bold" },
  input: { width: "60%", padding: "15px", borderRadius: "8px", border: "1px solid #333", background: "#1a1b26", color: "white" },
  btn: { padding: "15px 30px", background: "#ec008c", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontWeight: "bold" },
  previewCard: { background: "#1a1b26", padding: "20px", borderRadius: "12px", marginTop: "30px", textAlign: "left" },
  previewImg: { width: "100%", height: "250px", objectFit: "cover", borderRadius: "8px" },
  scrollContent: { maxHeight: "300px", overflowY: "auto", background: "#050505", padding: "15px", marginTop: "15px", borderRadius: "8px" },
  publishBtn: { width: "100%", padding: "20px", background: "#00ffcc", color: "#000", border: "none", borderRadius: "8px", fontWeight: "bold", marginTop: "20px", cursor: "pointer" }
};

export default AdminDashboard;